<template>
  <img width="24" height="24" :src="active ? require('../image/thumbs-down-red.png') : require('../image/thumbs-down.png')" :class="['item-icon', { 'is-disabled': disabled }]" />
</template>

<script>
export default {
  name: 'ThumbsDownIcon',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    strokeColor() {
      return this.active ? '#65a765' : 'currentColor';
    },
    fillColor() {
      return this.active ? 'none' : 'none';
    }
  },
}
</script>

<style lang="scss" scoped>
.item-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
}
.item-icon:hover {
  transform: scale(1.2);
}
.item-icon.is-disabled {
  cursor: not-allowed;
  opacity: 0.5;
  transform: none !important;
}
</style>